module.exports = __webpack_public_path__ + "static/media/toggle-on.fdd61aad.svg";